// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, string } from 'prop-types'

const ACMTrigger = props => {
  const {
    acmFlag,
    columnKey,
    idRoot,
    segmentEndId,
    TooltipTrigger,
  } = props

  // if ACM isn't enabled, render an unseen cell which preserves layout
  if (!acmFlag) {
    return (
      <div className={'tooltip-trigger-decoration acm-tooltip-decoration'}>{'ACM'}</div>
    )
  }

  return (
    <TooltipTrigger
      idRoot={idRoot}
      tooltipColumn={columnKey}
      tooltipData={segmentEndId}>
      <span className={'tooltip-trigger-decoration show-decoration acm-tooltip-decoration'}>
        {'acm'}
      </span>
    </TooltipTrigger>
  )
}

ACMTrigger.propTypes = {
  acmFlag: bool.isRequired,
  columnKey: string.isRequired,
  idRoot: string.isRequired,
  segmentEndId: number.isRequired,
  TooltipTrigger: func.isRequired,
}

export default ACMTrigger
